import { Colors } from './colors';
import { Variables } from './variables';

type Props = {
    fontSize: string;
    fontWeight: string;
    color?: string;
    fontFamily?: string;
    letterSpacing?: string;
};

export const TextStyle = ({
    fontSize,
    fontWeight,
    color = Colors.darkGray,
    fontFamily = Variables.montserrat,
    letterSpacing = '0.2px',
}: Props) => `
  font-size: ${fontSize};
  font-weight: ${fontWeight};
  color: ${color};
  font-family: ${fontFamily};
  letter-spacing: ${letterSpacing};
`;
